import { render, staticRenderFns } from "./QuoteReplicaTable.vue?vue&type=template&id=a9be6c66&scoped=true"
import script from "./QuoteReplicaTable.vue?vue&type=script&lang=js"
export * from "./QuoteReplicaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9be6c66",
  null
  
)

export default component.exports